import { render, staticRenderFns } from "./SendPaper.vue?vue&type=template&id=fe6be65e&scoped=true"
import script from "./SendPaper.vue?vue&type=script&lang=js"
export * from "./SendPaper.vue?vue&type=script&lang=js"
import style0 from "./SendPaper.vue?vue&type=style&index=0&id=fe6be65e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe6be65e",
  null
  
)

export default component.exports